<div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>Our Gallery</h2>
        <!-- <h3>Nurturing Every Child's Unique Potential</h3> -->
        <p>
          Welcome to our gallery, a visual journey through the world of Innovative Vision! 
          This page is a vibrant collection of moments that capture the essence of our programs and 
          the joy of learning. Here, you'll see our holistic approach in action—children engaged in sports, 
          expressing themselves through dramatics and dance, focusing on pottery, and finding inner peace in 
          yoga.
        </p>
      </div>
      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img src="assets/ivimg/galleryH.svg" alt="Girl Learning Pottery" class="img-fluid">
      </div>
    </div>
  </div>
</div>

<section class="py-5 text-center">
  <div class="container">
    <h2 class="fw-bold mb-3" style="color: #825800;">Moments That Matter</h2>
    <p class="mb-5" style="color: #825800;">
      Catch a glimpse of the program activities and students bonding through our recent events.
    </p>

    <div class="row g-3">
      <div class="col-12 col-md-4">
        <img src="assets/ivimg/I9.svg" class="img-fluid rounded shadow-sm w-100" alt="Event Image 1">
      </div>
      <div class="col-12 col-md-4">
        <img src="assets/ivimg/I10.svg" class="img-fluid rounded shadow-sm w-100" alt="Event Image 2">
      </div>
      <div class="col-12 col-md-4">
        <img src="assets/ivimg/I11.svg" class="img-fluid rounded shadow-sm w-100" alt="Event Image 3">
      </div>
      <div class="col-12 col-md-4">
        <img src="assets/ivimg/I12.svg" class="img-fluid rounded shadow-sm w-100" alt="Event Image 3">
      </div>
      <div class="col-12 col-md-4">
        <img src="assets/ivimg/I13.svg" class="img-fluid rounded shadow-sm w-100" alt="Event Image 3">
      </div>
      <div class="col-12 col-md-4">
        <img src="assets/ivimg/I14.svg" class="img-fluid rounded shadow-sm w-100" alt="Event Image 3">
      </div>
      <div class="col-12 col-md-4">
        <img src="assets/ivimg/I15.svg" class="img-fluid rounded shadow-sm w-100" alt="Event Image 3">
      </div>
    </div>
  </div>
</section>


